module.exports = __webpack_public_path__ + "static/img/10.ca0a2f12.png";